import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=323d4f31&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.scss?vue&type=style&index=0&id=323d4f31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d4f31",
  null
  
)

export default component.exports